// =============================================================================
// Home live search — filter the guide library as the visitor types and render
// matching guides below the input (title + topic + link), like the mockup.
// The index is a JSON payload rendered by the home template (#aa-search-index).
// =============================================================================

const esc = (s) =>
	String(s).replace(/[&<>"']/g, (c) => ({
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#39;',
	}[c]));

const init = () => {
	const input = document.getElementById('aa-search');
	const indexEl = document.getElementById('aa-search-index');
	const wrap = document.querySelector('.aa-home__search-results');
	if (!input || !indexEl || !wrap) {
		return;
	}

	const countEl = wrap.querySelector('.aa-home__search-count');
	const listEl = wrap.querySelector('.aa-home__results');
	const clearBtn = document.querySelector('.aa-home__search-clear');

	let index = [];
	try {
		index = JSON.parse(indexEl.textContent || '[]');
	} catch (e) {
		index = [];
	}

	// The live results replace the full-page submit; Enter should not navigate.
	const form = input.closest('form');
	if (form) {
		form.addEventListener('submit', (e) => e.preventDefault());
	}

	const render = () => {
		const q = input.value.trim().toLowerCase();
		if (clearBtn) {
			clearBtn.hidden = q === '';
		}

		if (!q) {
			wrap.hidden = true;
			listEl.innerHTML = '';
			return;
		}

		const hits = index.filter(
			(item) =>
				item.title.toLowerCase().includes(q) ||
				item.topic.toLowerCase().includes(q)
		);

		wrap.hidden = false;
		countEl.textContent = `${hits.length} Guide${hits.length === 1 ? '' : 's'}`;

		if (!hits.length) {
			listEl.innerHTML =
				'<p class="aa-home__search-empty">No guides match yet — try a simpler word like “printer” or “menu”.</p>';
			return;
		}

		listEl.innerHTML = hits
			.map(
				(item) => `
				<a class="aa-search-result" href="${esc(item.url)}">
					<span>
						<span class="aa-search-result__title">${esc(item.title)}</span>
						<span class="aa-search-result__topic">${esc(item.topic)}</span>
					</span>
					<span class="aa-search-result__chevron" aria-hidden="true">›</span>
				</a>`
			)
			.join('');
	};

	let timer;
	input.addEventListener('input', () => {
		clearTimeout(timer);
		timer = setTimeout(render, 120);
	});

	if (clearBtn) {
		clearBtn.addEventListener('click', () => {
			input.value = '';
			render();
			input.focus();
		});
	}
};

if ('loading' === document.readyState) {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
